import { render, staticRenderFns } from "./GhostItem.vue?vue&type=template&id=598d2189&scoped=true"
import script from "./GhostItem.vue?vue&type=script&lang=ts"
export * from "./GhostItem.vue?vue&type=script&lang=ts"
import style0 from "./GhostItem.vue?vue&type=style&index=0&id=598d2189&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598d2189",
  null
  
)

export default component.exports